export const NETWORK_EXPLANATION =
  "Direct referrals are users you personally referred. Level-wise network shows users referred under your team. Commission is calculated based on the final eligible purchase status as per system rules.";

export const PAGE_SIZE = 10;

export const formatCurrency = (value) =>
  `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

export const capitalize = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const mapLevelItem = (item) => ({
  level: Number(item?.level || 0),
  totalUsers: Number(item?.total_users || 0),
  businessGenerated: Number(item?.business_generated || 0),
  commissionEarned: Number(item?.commission_earned || 0),
  customUserId: item?.custom_user_id || null,
});

export const mapTreeItem = (item, index) => ({
  id: item?.id,
  name: item?.name || "Unnamed",
  level: Number(item?.level || 0),
  referredBy: item?.referred_by ?? null,
  referredByName: item?.referred_by_name || "—",
  createdAt: item?.created_at || null,
  order: index,
  customUserId: item?.custom_user_id || null,
});

export const mapDirectReferral = (item) => ({
  id: item?.id,
  userId: item?.custom_user_id || item?.id ? `USR${item.id}` : "—",
  name: item?.name || "—",
  email: item?.email || "—",
  mobile: item?.mobile_number || "—",
  joinDate: item?.created_at,
  status: item?.status || "—",
  businessAmount: Number(item?.business_amount || 0),
  courseName: item?.course_name || "",
  hasPurchase: Number(item?.business_amount || 0) > 0 || Boolean(item?.course_name),
  customUserId: item?.custom_user_id || null,
});

export const buildHierarchy = (items = []) => {
  const nodeMap = new Map();
  const roots = [];

  items.forEach((item) => {
    nodeMap.set(item.id, { ...item, children: [] });
  });

  items.forEach((item) => {
    const node = nodeMap.get(item.id);
    const parentId = item.referredBy;
    if (parentId != null && nodeMap.has(parentId)) {
      nodeMap.get(parentId).children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
};

export const getUsersAtLevel = (treeFlat = [], level) =>
  treeFlat.filter((u) => Number(u.level) === Number(level));

export const countPurchasedInList = (referrals = []) =>
  referrals.filter((r) => r.hasPurchase).length;

export const getPurchaseBadge = (hasPurchase) =>
  hasPurchase
    ? { bg: "success", label: "Purchased" }
    : { bg: "secondary", label: "Not Purchased" };

export const getLevelBadge = (level) => ({
  bg: level === 1 ? "primary" : "info",
  label: level === 1 ? "Direct Referral" : `Level ${level}`,
});

export const filterTreeUsers = (users = [], { search = "", purchasedOnly, unpurchasedOnly } = {}) => {
  const q = search.trim().toLowerCase();
  return users.filter((user) => {
    if (q) {
      const haystack = [user.name, String(user.id), user.email, user.mobile]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(q) && !haystack.split(" ").some((part) => part.includes(q))) {
        const match =
          String(user.name || "").toLowerCase().includes(q) ||
          String(user.id || "").includes(q);
        if (!match) return false;
      }
    }
    if (purchasedOnly && !user.hasPurchase) return false;
    if (unpurchasedOnly && user.hasPurchase) return false;
    return true;
  });
};
